import React from 'react';

/**
 * Skeleton loading placeholder for template cards.
 * Shown while templates are being fetched/rendered.
 * Mimics the structure of a resume template card.
 */
const TemplateSkeletonCard = () => {
  return (
    <div className="template-card skeleton-card">
      <div className="template-preview-wrapper skeleton-wrapper">
        <div className="skeleton-content">
          {/* Header area */}
          <div className="skeleton-header">
            <div className="skeleton-line skeleton-name"></div>
            <div className="skeleton-line skeleton-title"></div>
            <div className="skeleton-line skeleton-contact"></div>
          </div>
          
          {/* Summary section */}
          <div className="skeleton-section">
            <div className="skeleton-line skeleton-heading"></div>
            <div className="skeleton-line skeleton-text"></div>
            <div className="skeleton-line skeleton-text"></div>
            <div className="skeleton-line skeleton-text-short"></div>
          </div>
          
          {/* Experience section */}
          <div className="skeleton-section">
            <div className="skeleton-line skeleton-heading"></div>
            <div className="skeleton-line skeleton-subheading"></div>
            <div className="skeleton-line skeleton-text"></div>
            <div className="skeleton-line skeleton-text"></div>
          </div>
          
          {/* Education section */}
          <div className="skeleton-section">
            <div className="skeleton-line skeleton-heading"></div>
            <div className="skeleton-line skeleton-text"></div>
            <div className="skeleton-line skeleton-text-short"></div>
          </div>
        </div>
      </div>
      <div className="template-info">
        <div className="skeleton-line skeleton-name-bar"></div>
      </div>
    </div>
  );
};

export default TemplateSkeletonCard;
